import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { ReactSVG } from 'react-svg'
import { isMobile, isDesktop } from '../../classes/Platform.js'
import { delay, countTokens } from '../../classes/Util.js'
import AICheck from '../../assets/Icons/AICheck.svg'
import Spin from '../../assets/Icons/Spin.svg'
import Cross from '../../assets/Icons/Cross.svg'
import Trash from '../../assets/Icons/Trash.svg'
import Stop from '../../assets/Icons/Stop.svg'
import MenuUp from '../../assets/Icons/MenuUp.svg'
import MenuDown from '../../assets/Icons/MenuDown.svg'
import Category from '../../assets/Icons/UserSaid.svg'
import OpenFile from '../../assets/Icons/OpenFile.svg'
import File from '../../assets/Icons/File.svg'
import Image from '../../assets/Icons/Image.svg'
import Save from '../../assets/Icons/SaveCommand.svg'
import Undo from '../../assets/Icons/Redo.svg'
import Redo from '../../assets/Icons/Undo.svg'

import Send from '../../assets/Icons/Send.svg'
import Cut from '../../assets/Icons/Share.svg'
import Copy from '../../assets/Icons/Copy.svg'
import Share from '../../assets/Icons/Share.svg'
import UserSaid from '../../assets/Icons/UserSaid.svg'
import AISaid from '../../assets/Icons/AISaid.svg'
import CheckMark from '../../assets/Icons/Tick.svg'
import EditIcon from '../../assets/Icons/Edit.svg'
import Left from '../../assets/Icons/Back.svg'
import Right from '../../assets/Icons/Forward.svg'
import Alert from '../../assets/Icons/Alert.svg'
import Hashtag from '../../assets/Icons/Hashtag.svg'
import Question from '../../assets/Icons/Question.svg'
import Marker from '../../assets/Icons/Marker.svg'
import Gear from '../../assets/Icons/Settings.svg'
import Filter from '../../assets/Icons/Filter.svg'
import ClickAwayListener from 'react-click-away-listener'
import Popup from 'reactjs-popup'
import './SimpleButton.css'
const MIN_ANIM_DUR = 1.0

export class SimpleConfigButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      selected: false
    }
  }
  render() {
    const { label, icon, children, action } = this.props
    const {active, selected} = this.state
    let className = 'simpleButtonConfigPopup'
    if (active) {
      if (selected) {
        className += ' simpleButtonConfigPopupActiveSelected'
      } else {
        className += ' simpleButtonConfigPopupActive'
    }
    } else if (selected) {
      className += ' simpleButtonConfigPopupSelected'
    }
    const trigger = <div id={'simpleButtonMenuTrigger'}>
                      <SimpleIcon src={Filter}/>
                    </div>
    let className0 = 'simpleButtonConfigPopupContainer'
    if (isMobile()) {
      className0 += ' simpleButtonConfigPopupMobile'
    }
    const config = <Popup closeOnDocumentClick position='bottom left' trigger={trigger}>
                     {close =>
                       <div className={className0}>
                         <div className={className}>
                           {children}
                         </div>
                       </div>
                     }
                   </Popup>
    return <div className='simpleButtonWithConfig'>
             <SimpleButton label={label} icon={icon} action={action}/>
             {config}
           </div>
  }
}

export class FileChooser extends Component {

  setFileChooser = ref => {
    this.fileChooser = ref
  }

  componentDidMount() {
    if (this.props.onCreate) {
      this.props.onCreate(this)
    }
  }

  reset = () => {
    this.fileChooser.value = ''
  }

  chooseFile = () => this.fileChooser.click()

  render() {
    let { button, icon, label, handleDataTransfer, fileTypes, action } = this.props
    const noAction = (async () => {})
    if (!icon) {
      icon = OpenFile
    }
    if (!button) {
      button = <SimpleButton icon={icon} label={label} action={noAction}/>
    }
    const open = async (event) => {
      this.fileChooser.click()
    }
    const onChange = async (event) => {
      if (action) action()
      handleDataTransfer(event, event.target)
      this.fileChooser.value = ''
    }
    const fileChooser = 
      <div className='fileChooser' onClick={open}>
        <input
          ref={this.setFileChooser}
          type={"file"}
          accept={fileTypes}
          style={{ display: 'none' }} // Hides the file input
          onChange={onChange}
        />                      
        {button}
      </div>
    return fileChooser
  }
}

export class DeleteButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  trash = async () => {
    if (!this.state.confirmDelete) {
      this.state.confirmDelete = true
      this.forceUpdate()
      return
    }
    this.state.busy = true
    this.forceUpdate()
    const start = Date.now()
    await this.props.trash()
    const end = Date.now()
    const elapsed = (end - start) / 1000
    const dur = MIN_ANIM_DUR - elapsed
    if (dur > 0) {
      await delay(dur)
    }
    this.state.busy = false
    this.state.confirmDelete = null
    this.forceUpdate()
  }

  cancelDelete = async () => {
    this.setState({
      confirmDelete: false
    })
  }

  render() {
    const { label, confirm } = this.props
    let deleteButton
    let deleteIcon = this.state.busy ? Spin : (this.props.icon || Trash)
    const trash = () => this.trash()
    let Delete = this.props.Delete || 'Delete'
    let className='threadDeleteButton'
    const confirmLabel = (confirm || "Confirm") + "?"
    if (label) {
      className += ' threadDeleteButtonWithLabel'
    }
    if (this.state.confirmDelete) {
      deleteButton = <div key='delete' className='threadDeleteButtonConfirm'><SimpleButton label={confirmLabel} icon={deleteIcon} action={trash}/></div>
      if (!this.props.noClickAway) {
        deleteButton = <ClickAwayListener onClickAway={this.cancelDelete}>
                         {deleteButton}
                       </ClickAwayListener>
        
      }
    } else {
      deleteButton = <div key='del' className={className}><SimpleButton label={label} action={trash} icon={deleteIcon}/></div>
    }
    return <div className='deleteButtonHolder'>{deleteButton}</div>
  }
}

export class SimpleIcon0 extends Component {
  constructor (props) {
    super(props)
  }

  afterInjection = svg => {
    this.svg = svg
  }
  setRef = ref => {
    this.ref = ref
  }
  render() {
    const { src, size, legacyIconSize } = this.props
    let style
    let className = 'simpleIcon'
    if (false && this.svg && this.ref) {
      const [x, y, w, h] = this.svg.attributes.viewBox.value.split(" ").map(x => parseFloat(x))
      const box = this.ref.getBoundingClientRect()
      if (w === box.width) {
        this.svg.style.width = box.width + 'px'
        this.svg.style.height = box.height + 'px'
      }
    }
    if (size) {
      const { w, h } = size
      style = {
        height: h,
        width: w,
        minWidth: w
      }
      className += ' simpleIconWithSize'
    }
    if (legacyIconSize) {
      className += ' legacyIconSize'
    }
    return <div ref={this.setRef} className={className} style={style}><ReactSVG afterInjection={this.afterInjection} src={src}/></div>
  }
}

export class SimpleButton0 extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  setRef = ref => {
    this.ref = ref
  }

  componentWillUnmount() {
    if (this.timeout1) {
      ////console.log("unmount autorepeat")
      clearTimeout(this.timeout1)
    }
  }

  action = async () => {
    if (this.state.busy) return
    if (!this.props.action) return
    this.state.busy = true
    this.forceUpdate()
    const start = Date.now()
    const done = () => {
      this.state.busy = false
      this.forceUpdate()
    }
    await this.props.action()
    const end = Date.now()
    const elapsed = (end - start) / 1000
    const dur = MIN_ANIM_DUR - elapsed
    if (dur > 0) {
      //await delay(dur)
    }
    done()
  }
  
  render() {
    const props = this.props
    let { icon, label } = props
    let action
    let className = 'simpleButton'
    if (label) {
      if (typeof(label) !== 'string') {
        className += ' simpleButtonLabelComponent'
      } else {
        className += ' simpleButtonWithLabel'
      }
    } else {
      className += ' simpleButtonNoLabel'
    }
    if (icon) {
      className += ' simpleButtonWithIcon'
    }
    if (props.action) {
      action = async () => {
        this.state.busy = true
        setTimeout(() => this.forceUpdate())
        //this.ref.scrollIntoView()
        await props.action()
        this.state.busy = false
        this.forceUpdate()
      }
    } else{
      className += ' simpleButtonInactive'
    }
    if (this.props.busy || this.state.busy) icon = Spin
    let longPressOps
    let onClick
    if (this.props.longPress) {
      longPressOps = this
      className += ' simpleButtonLongPressable'
    } else if (this.props.autoRepeat) {
      className += ' simpleButtonAutorepeat'
      const onHold = () => {
        ////console.log("onHold", this.down)
        clearTimeout(this.timeout1)
        props.action()
        this.timeout1 = setTimeout(onHold, 100)
      }
      const hold = () => {
        onHold()
      }
      const release = () => {
        this.down = false
        clearTimeout(this.timeout1)
        this.timeout = null
      }
      longPressOps = {
        handleMouseDown: e => {
          e.preventDefault()
          e.stopPropagation()
          hold()
        },
        handleMouseUp: e => {
          e.preventDefault()
          e.stopPropagation()          
          release()
        },
        handleMouseLeave: e => {
          release()
        },
        handleTouchStart: e => {
          e.preventDefault()
          e.stopPropagation()          
          hold()
        },
        handleTouchEnd: e => {
          e.preventDefault()
          e.stopPropagation()
          release()
        }
      }
    } else {
      longPressOps = {}
      if (this.props.keepFocus) {
        onClick = (event) => {
          event.preventDefault()
          this.action()
        }
      } else {
        onClick = this.action
      }
    }
    const legacyIconSize = !this.state.busy && this.props.legacyIconSize
    return <div ref={this.setRef}
                className={className}
                onClick={onClick}
                onMouseDown={longPressOps.handleMouseDown}
                onMouseUp={longPressOps.handleMouseUp}
                onMouseLeave={longPressOps.handleMouseLeave}
                onTouchStart={longPressOps.handleTouchStart}
                onTouchEnd={longPressOps.handleTouchEnd}
           >
             {icon && <SimpleIcon size={this.props.iconSize} key='icon' src={icon} legacyIconSize={legacyIconSize}/>}
             {label &&<div key='label' className='simpleButtonLabel'>
                        {label}
                      </div>}
           </div>

  }

  startPressTimer = () => {
    const { pressDuration = 300 } = this.props
    this.state.pressed = true
    this.setState({ isLongPress: false })
    this.timerRef = setTimeout(() => {
      this.setState({ isLongPress: true })
      if (navigator.vibrate) {
        navigator.vibrate(200);
      } else {
      }
      ////console.log("long press called")
      this.props.longPress()
    }, pressDuration);
  }

  cancelPressTimer = () => {
    this.state.pressed = false
    clearTimeout(this.timerRef)
    if (this.props.longPress && this.state.isLongPress) {
      function clearSelection() {
        if (window.getSelection) {
          // For most modern browsers
          window.getSelection().removeAllRanges()
        } else if (document.selection) {
          // For older IE browsers
          document.selection.empty()
        }
      }
      setTimeout(clearSelection, 60)
    } else {
      this.action()
    }
  };

  handleMouseDown = (e) => {
    this.startPressTimer();
    e.preventDefault()
  };

  handleMouseUp = (e) => {
    e.preventDefault()
    this.cancelPressTimer();
  }

  handleTouchStart = (e) => {
    e.preventDefault()
    this.startPressTimer();
  };

  handleTouchEnd = (e) => {
    e.preventDefault()
    this.cancelPressTimer();
  };

  
}

export const GearButton = props => {
  return <SimpleButton legacyIconSize icon={Gear} {...props}/>
}

export const GearIcon = props => {
  return <SimpleIcon legacyIconSize src={Gear} {...props}/>
}

export const LegacyButton = props => {
  return <SimpleButton legacyIconSize {...props}/>
}

export class SimpleIcon extends Component {
  constructor (props) {
    super(props)
  }
  afterInjection = svg => {
    if (svg) {
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet')
      if (!svg.getAttribute('viewBox')) {
        const width = parseFloat(svg.getAttribute('width'))
        const height = parseFloat(svg.getAttribute('height'))
        if (width && height) {
          svg.setAttribute('viewBox', `0 0 ${width} ${height}`)
        }
      }
      svg.removeAttribute('width')
      svg.removeAttribute('height')
      svg.style.width = '100%'
      svg.style.height = '100%'
      svg.style.maxWidth = '100%'
      svg.style.maxHeight = '100%'
      svg.style.display = 'block'
    }
  }
  render() {
    const { src, size, legacyIconSize } = this.props
    let style
    let className = 'simpleIcon'
    if (size) {
      const { w, h } = size
      style = {
        height: h,
        width: w,
        minWidth: w
      }
      className += ' simpleIconWithSize'
    }
    if (legacyIconSize) {
      className += ' legacyIconSize'
    }
    return <div className={className} style={style}><ReactSVG afterInjection={this.afterInjection} src={src}/></div>
  }
}

export class SimpleButton extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  setRef = ref => {
    this.ref = ref
  }

  componentWillUnmount() {
    if (this.timeout1) {
      console.log("unmount autorepeat")
      clearTimeout(this.timeout1)
    }
  }

  action = async (fun) => {
    if (!fun) return
    this.state.busy = true
    this.forceUpdate()
    await fun()
    this.state.busy = false
    this.forceUpdate()
  }
  
  render() {
    const props = this.props
    let { icon, label, doubleClickAction } = props
    let action
    let className = 'simpleButton'
    if (label) {
      if (typeof(label) !== 'string') {
        className += ' simpleButtonLabelComponent'
      } else {
        className += ' simpleButtonWithLabel'
      }
    }
    if (icon) {
      className += ' simpleButtonWithIcon'
    }
    if (props.action) {
      action = async () => {
        if (this.state.busy) {
          return
        }
        this.state.busy = true
        setTimeout(() => this.forceUpdate())
        //this.ref.scrollIntoView()
        try {
          await props.action()
        } finally {
          this.state.busy = false
        }
        this.forceUpdate()
      }
    } else {
      className += ' simpleButtonInactive'
    }
    if (this.state.busy) icon = Spin
    let longPressOps
    let onClick
    let onDoubleClick
    if (this.props.longPress) {
      longPressOps = this
      className += ' simpleButtonLongPressable'
    } else if (this.props.autoRepeat) {
      className += ' simpleButtonAutorepeat'
      const onHold = () => {
        console.log("onHold", this.down)
        clearTimeout(this.timeout1)
        props.action()
        this.timeout1 = setTimeout(onHold, 100)
      }
      const hold = () => {
        onHold()
      }
      const release = () => {
        this.down = false
        clearTimeout(this.timeout1)
        this.timeout = null
      }
      longPressOps = {
        handleMouseDown: e => {
          e.preventDefault()
          e.stopPropagation()
          hold()
        },
        handleMouseUp: e => {
          e.preventDefault()
          e.stopPropagation()          
          release()
        },
        handleMouseLeave: e => {
          release()
        },
        handleTouchStart: e => {
          e.preventDefault()
          e.stopPropagation()          
          hold()
        },
        handleTouchEnd: e => {
          e.preventDefault()
          e.stopPropagation()
          release()
        }
      }
    } else {
      longPressOps = {}
      if (this.props.keepFocus) {
        if (props.action) {
          onClick = (event) => {
            event.preventDefault()
            this.action(props.action, true)
          }
        }
      } else {
        if (props.action) {
          onClick = event => {
            if (event.detail === 2) { // hack
              if (props.doubleClickAction) {
                this.action(props.doubleClickAction)
                return
              }
            }
            this.action(props.action)
          }
        }
        if (false && props.doubleClickAction) { // doesn't work
          onDoubleClick = event => {
            console.log("double click")
            this.action(props.doubleClickAction)
          }
        }
      }
    }
    const legacyIconSize = !this.state.busy && this.props.legacyIconSize
    return <div ref={this.setRef}
                className={className}
                onClick={onClick}
                onDoubleClick={onDoubleClick}
                onMouseDown={longPressOps.handleMouseDown}
                onMouseUp={longPressOps.handleMouseUp}
                onMouseLeave={longPressOps.handleMouseLeave}
                onTouchStart={longPressOps.handleTouchStart}
                onTouchEnd={longPressOps.handleTouchEnd}
           >
             {icon && <SimpleIcon size={this.props.iconSize} key='icon' src={icon} legacyIconSize={legacyIconSize}/>}
             {label &&<div key='label' className='simpleButtonLabel'>
                        {label}
                      </div>}
           </div>

  }

  startPressTimer = () => {
    const { pressDuration = 300 } = this.props
    this.state.pressed = true
    this.setState({ isLongPress: false })
    this.timerRef = setTimeout(() => {
      this.setState({ isLongPress: true })
      if (navigator.vibrate) {
        navigator.vibrate(200);
      } else {
      }
      console.log("long press called")
      this.props.longPress()
    }, pressDuration);
  }

  cancelPressTimer = () => {
    this.state.pressed = false
    clearTimeout(this.timerRef)
    if (this.props.longPress && this.state.isLongPress) {
      function clearSelection() {
        if (window.getSelection) {
          // For most modern browsers
          window.getSelection().removeAllRanges()
        } else if (document.selection) {
          // For older IE browsers
          document.selection.empty()
        }
      }
      setTimeout(clearSelection, 60)
    } else {
      this.action()
    }
  };

  handleMouseDown = (e) => {
    this.startPressTimer();
    e.preventDefault()
  };

  handleMouseUp = (e) => {
    e.preventDefault()
    this.cancelPressTimer();
  }

  handleTouchStart = (e) => {
    e.preventDefault()
    this.startPressTimer();
  };

  handleTouchEnd = (e) => {
    e.preventDefault()
    this.cancelPressTimer();
  };

  
}

export const Checkbox = props => {
  let { icon, selected, toggle, label, keepFocus } = props
  if (!icon && !label) {
    icon = CheckMark
  }
  let className = 'simpleCheckbox'
  if (icon) {
    className += ' simpleCheckboxWithIcon'
  }
  if (selected) {
    className += ' simpleCheckboxSelected'
  }
  if (!label) {
    className += ' simpleCheckboxNoLabel'
  }
  if (props.className) {
    className += ' ' + props.className
  }
  let onClick
  let onMouseDown
  if (keepFocus) {
    onMouseDown = e => {
      e.preventDefault()
      toggle()
    }
  } else {
    onClick = toggle
  }
  return <div className={className} onClick={onClick} onMouseDown={onMouseDown}>
           {icon && <div className='simpleCheckboxIcon'><ReactSVG src={icon}/></div>}
           {label}
           </div>
}

export class RadioButtons extends Component {
  render() {
    const isSmall = this.props.small
    const buttons = this.props.buttons.map(button => {
      const { selected, label, icon, select } = button
      return <Checkbox icon={icon} toggle={select} label={label} selected={selected}/>
    });
    return <div className={'keyboardRadioButton' +  (isSmall ? ' keyboardRadioButtonSmall' : '')}>
             {this.props.label &&<div className='keyboardRadioButtonLabel keyboardRadioButton'>
               {this.props.label}
                                 </div>}
             {buttons}
             <div className='keyboardRadioButtonRight'/>
           </div>

  }
}


class CheckboxPopup extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  renderMenu = () => {
    return ReactDOM.createPortal(this.doRenderMenu(), getPortal())
  }

  doRenderMenu = () => {
    const closeMenu = () => {
      this.state.menuActive = false
      his.forceUpdate()
    }
    return <ClickAwayListener onClickAway={closeMenu}>    
             <RadioButtons buttons={this.props.buttons}/>
           </ClickAwayListener>
  }

  render() {
    const onClick = async () => {
      setTimeout(() =>  {
        this.setState({
          menuActive: !this.state.menuActive
        })
      }, 50)
    }
    return <div className='chatGptFunctions'>
             <div className='keyboardAddButton'>
               <KeyboardButton1 keepFocus icon={this.state.menuActive ? MenuDown : MenuUp} action={onClick}/>
             </div>
           </div>
  }
  
}
